import { Box } from '@material-ui/core'
import { Button } from 'components/facets'
import { ActionCard } from 'components/facets/ActionCard'
import { useOnboardingStore } from 'lib/hooks/useOnboardingStore'
import { FetchedStockInterface } from 'lib/hooks/useStockStore'
import { useTranslation } from 'react-i18next'
import { InventoryArticle, ONBOARDING_STEPS } from 'shared'

export interface OnboardingChooseNextStepProps {
  setVisitedSteps: (value: React.SetStateAction<number[]>) => void
  inventoryState: FetchedStockInterface
  setUserOnboarded: (updatedInventory: InventoryArticle[]) => Promise<void>
}

export const ChooseNextStep = ({
  setVisitedSteps,
  inventoryState,
  setUserOnboarded,
}: OnboardingChooseNextStepProps): JSX.Element => {
  const { t } = useTranslation()
  const { setOnboardingStep } = useOnboardingStore()

  return (
    <>
      <div className="d-flex justify-content-center w-100 onboarding-container">
        <div className="wizard-content mt-lg-5 container">
          <div className="row justify-content-between">
            <div className="col-lg-6 pe-lg-5 mb-lg-0 mb-4">
              <h3 className="fw-normal">{t('onboarding.selectCommentsAndLocations')}</h3>
              <p className="fs-6 m-0 p-0 fw-light">{t('onboarding.nextStepOne')}</p>
              <p className="fs-6 m-0 p-0 fw-light">{t('onboarding.nextStepTwo')}</p>
              <p className="fs-6 fw-light">{t('onboarding.nextStepThree')}</p>
              <ul>
                <li className="fs-6 mb-1 fw-light">{t('onboarding.nextStepFour')}</li>
                <li className="fs-6 fw-light">{t('onboarding.nextStepFive')}</li>
              </ul>
            </div>

            <div className="col-lg-6">
              <div className="mb-4">
                <ActionCard
                  variant="withDescription"
                  title={t('onboarding.usePtInterfaceTitle')}
                  description={t('onboarding.usePtInterface')}
                  button={
                    <Box width={250}>
                      <Button
                        variant="contained"
                        data-testid="use-pt-interface"
                        onClick={() => {
                          setVisitedSteps((prev) => [
                            ...prev,
                            ONBOARDING_STEPS.SET_COMMENTS_LOCATIONS.idx,
                          ])
                          setOnboardingStep(ONBOARDING_STEPS.SET_COMMENTS_LOCATIONS.idx)
                        }}
                        style={{ width: '250px' }}
                      >
                        {t('onboarding.usePtInterfaceBtn')}
                      </Button>
                    </Box>
                  }
                />
              </div>

              <div className="mb-4">
                <ActionCard
                  variant="withDescription"
                  title={t('onboarding.useCsvTitle')}
                  description={t('onboarding.useCsv')}
                  button={
                    <Box width={250}>
                      <Button
                        variant="contained"
                        data-testid="use-csv"
                        onClick={() => {
                          setVisitedSteps((prev) => [
                            ...prev,
                            ONBOARDING_STEPS.DOWNLOAD_FETCHED_STOCK.idx,
                          ])
                          setOnboardingStep(ONBOARDING_STEPS.DOWNLOAD_FETCHED_STOCK.idx)
                        }}
                        style={{ width: '250px' }}
                      >
                        {t('onboarding.useCsvBtn')}
                      </Button>
                    </Box>
                  }
                />
              </div>

              <div className="mb-4">
                <ActionCard
                  variant="withDescription"
                  title={t('onboarding.useAutomaticPtTitle')}
                  description={t('onboarding.useAutomaticPt')}
                  button={
                    <Box width={250}>
                      <Button
                        variant="contained"
                        data-testid="let-powertools-manage"
                        onClick={() => {
                          setUserOnboarded(inventoryState.stock.concat(inventoryState.sealedStock))
                        }}
                        style={{ width: '250px' }}
                      >
                        {t('onboarding.useAutomaticPtBtn')}
                      </Button>
                    </Box>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
